import React, { useEffect, useState } from 'react';
import styles from './CTA.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import classNames from 'classnames';

import { motion, usePresence } from 'framer-motion';

const CTA = React.memo(({ title }) => {
  const { questionFontSize, descriptionFontSize } = useGetParams();

  const [isPresent, safeToRemove] = usePresence();
  const [isExiting, setIsExiting] = useState(false);

  const titleRows = title.split('\n').map((el) => el.trim());

  useEffect(() => {
    if (!isPresent) {
      setIsExiting(true);

      const timer = setTimeout(() => {
        safeToRemove();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isPresent, safeToRemove]);

  return (
    <div className={classNames(styles.container)}>
      {titleRows.slice(0, -1).map((row, index) => (
        <motion.div
          key={`cta-title-${index}`}
          initial={{ scale: 20, opacity: 0 }}
          animate={
            isExiting
              ? {
                  scale: 1,
                  opacity: 1,
                }
              : {
                  scale: [20, 1, 1, 0],
                  opacity: [0, 1, 1, 0],
                }
          }
          transition={
            isExiting
              ? {
                  duration: 0.8,
                  ease: 'easeOut',
                }
              : {
                  times: [0, 1 / 6, 5 / 6, 1],
                  duration: 6,
                  delay: index * 0.5,
                  repeat: Infinity,
                  repeatDelay: 2,
                }
          }
        >
          <h1
            className={classNames(styles.title, {
              [styles.accent]: index === 2,
              [styles.small]: index === 3,
            })}
            style={{ fontSize: `${questionFontSize}rem` }}
          >
            {row}
          </h1>
        </motion.div>
      ))}

      {titleRows.slice(-1).map((description, index) => (
        <motion.div
          key={`cta-description-${index}`}
          initial={{ opacity: 0 }}
          animate={isExiting ? { opacity: 1 } : { opacity: [0, 1, 1, 0] }}
          transition={
            isExiting
              ? {
                  duration: 0.5,
                }
              : {
                  times: [0, 1 / 6, 5 / 6, 1],
                  duration: 5,
                  delay: 2,
                  repeat: Infinity,
                  repeatDelay: 3,
                }
          }
        >
          <h1
            className={styles.description}
            style={{ fontSize: `${descriptionFontSize}rem` }}
          >
            {description}
          </h1>
        </motion.div>
      ))}
    </div>
  );
});

export default CTA;
